import React, {useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import DialogActions from '@mui/material/DialogActions';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import axios from 'axios'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const filter = createFilterOptions();

const materialTheme = createTheme(({
  // set default for now
}));

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp(props) {
  const classes = useStyles();
  const [showRegisteringProgress,setShowRegisteringProgress] = useState(false)
  const [showGettingLocationProgress,setShowGettingLocationProgress] = useState(false)
  const [openAlertDialog,setOpenAlertDialog] = useState(false)
  const [hasErrorInRegistration,setHasErrorInRegistration] = useState(false)
  const [registrationErrors,setRegistrationErrors] = useState([])
  const [newUser,setNewUser] = useState({
    first_name:'',
    last_name:'',
    username:'',
    password:'',
    retype_password:'',
    end_user_agreement_agreed:false,
    latitude:'',
    longitude:'',
    accuracy:0
  })
  
    const [provinceAutoCompeleteValue, setProvinceAutoCompeleteValue] = useState({id:0,provCode:0,provDesc:"",psgcCode:"0",regCode:""});
    const [provinceAutoCompeleteSuggestion,setProvinceAutoCompeleteSuggestion] = useState([])
    const [selectedProvince,setSelectedProvince] = useState()
    
    const [cityMunicipalityAutoCompeleteValue, setCityMunicipalityAutoCompeleteValue] = useState({id:0,psgcCode:"",citymunDesc:"",regDesc:"",provCode:"",citymunCode:""});
    const [cityMunicipalityAutoCompeleteSuggestion,setCityMunicipalityAutoCompeleteSuggestion] = useState([])
    const [selectedCityMunicipality,setSelectedCityMunicipality] = useState()

    const [barangayAutoCompeleteValue, setBarangayAutoCompeleteValue] = useState({id:0,brgyCode:"",brgyDesc:"",regCode:"",provCode:"",citymunCode:""});
    const [barangayAutoCompeleteSuggestion,setBarangayAutoCompeleteSuggestion] = useState([])
    const [selectedBarangay,setSelectedBarangay] = useState([])


    const [disableCityMunicipalityAutoSuggest,setDisableCityMunicipalityAutoSuggest] = useState(true)
    const [disableBarangayAutoSuggest,setDisableBarangayAutoSuggest] = useState(true)
    const [disableBarangayInput,setDisableBarangayInput] = useState(true)

    const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")

  
  const firstNameOnChange = (event)=>{
    newUser.first_name = event.target.value
  }
  const lastNameOnChange = (event)=>{
    newUser.last_name = event.target.value
  }
  const usernameOnChange = (event)=>{
    newUser.username = event.target.value
  }
  const passwordOnChange = (event)=>{
    newUser.password = event.target.value
  }
  const retypePasswordOnChange = (event)=>{
    newUser.retype_password = event.target.value
  }
  const storeNameOnChange = (event)=>{
    newUser.store_name = event.target.value
  }
  const mobileNumberOnChange = (event)=>{
    newUser.mobile_number = event.target.value
  }
  const emailOnChange = (event)=>{
    newUser.email = event.target.value
  }
 
  const streetOnChange = (event)=>{
    newUser.street = event.target.value
  }
  const endUserAgreementhOnChange = (event) => {
    
    newUser.end_user_agreement_agreed = event.target.checked
   
  };

  function failedToRegisterView(){
    return(
      <>
        <List>
             {
                 registrationErrors.map((registrationError,index)=>{ 
                     return(
                         
                         <ListItem divider key={index}>
                           {registrationError}
                         </ListItem>
                    
                     )
                 })
                
             }
             
             </List>
      </>
    )
  }


  function alertDialog(){
    return(
      <>
       <Dialog
        open={openAlertDialog}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={()=>{}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
       
        <DialogContent>
         
        <Typography variant="h6" component="h2" style={{color:(hasErrorInRegistration ? "red":"green")}}>
          { hasErrorInRegistration ? "Failed to register. Please check error below.":"You are successfully registered."  }
        </Typography>
          {
            hasErrorInRegistration ? failedToRegisterView():""          
          }
        </DialogContent>
        <DialogActions>
          <Button 
          onClick={()=>{
            
            setOpenAlertDialog(false)
            if(!hasErrorInRegistration){
              props.setIsSignUp(false)
            }
            
          }} 
          color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      </>
    )
  }
  function progressDialog(){
    return(
      <>
      <Dialog fullWidth={true} maxWidth={"sm"} open={showRegisteringProgress}>
        <DialogContent>
          <DialogContentText>Registering... Please wait...</DialogContentText>

          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        </DialogContent>
      </Dialog>
      </>
    )
  }

  function gettinLocationProgressDialog(){
    return(
      <>
      <Dialog fullWidth={true} maxWidth={"sm"} open={showGettingLocationProgress}>
        <DialogContent>
          <DialogContentText>Getting your location... Please wait...</DialogContentText>

          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        </DialogContent>
      </Dialog>
      </>
    )
  }

  function provinceAutoComplete() {

    return (
      <Autocomplete
          value={provinceAutoCompeleteValue}
          noOptionsText={autoCompleteSearchOptionMessage}
          onChange={(event, newValue) => {
              if( newValue == null){
                  setSelectedProvince(null)
                  return
              }
              setProvinceAutoCompeleteValue(newValue)
              setSelectedProvince(newValue)

          }}
          filterOptions={(options, params) => {
              
              return filter(options, params);
          }}
          onOpen={()=>{

              setSelectedProvince(null)

              const newCityMunicipalityAutoCompeleteValue =  {id:0,psgcCode:"",citymunDesc:"",regDesc:"",provCode:"",citymunCode:""}
              setCityMunicipalityAutoCompeleteValue(newCityMunicipalityAutoCompeleteValue)

              const newBarangayAutoCompeleteValue = {id:0,brgyCode:"",brgyDesc:"",regCode:"",provCode:"",citymunCode:""}
              setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue)



              setDisableCityMunicipalityAutoSuggest(true)
              setDisableBarangayAutoSuggest(true)
              setDisableBarangayInput(true)

          }}
          onClose={(event,reason)=>{
              
              if(reason != 'selectOption'){
                  // no selected data
                  return
              }
             
              setDisableCityMunicipalityAutoSuggest(false)
              
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          style={{width: '100%'}}
          options={provinceAutoCompeleteSuggestion}
          isOptionEqualToValue={(option, value) =>true}
          getOptionLabel={(option) => {
                
                  return option.provDesc;
          }}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.provDesc}>
                {option.provDesc}
              </li>
            );
          }}

          renderInput={(params) => (
              <TextField {...params} 
              InputProps={{ ...params.InputProps,className:classes.fullWidth}}
              className={classes.fullWidth}
              name="province *"
              label="Province"
              id="province"
              variant="outlined"
              onChange={(event)=>{

                   const newProvinceAutoCompeleteValue = {id:0,provCode:"0",provDesc:event.target.value,psgcCode:"0",regCode:""}
                  
                   setProvinceAutoCompeleteValue(newProvinceAutoCompeleteValue)
              }}
               />
          )}
      />
    );
}

function cityMunicipalityAutoComplete() {

    return (
      <Autocomplete
          disabled={disableCityMunicipalityAutoSuggest}
          value={cityMunicipalityAutoCompeleteValue}
          noOptionsText={autoCompleteSearchOptionMessage}
          onChange={(event, newValue) => {
              
              if( newValue == null){
                  setSelectedCityMunicipality(null)
                  return
              }
              setCityMunicipalityAutoCompeleteValue(newValue)
              setSelectedCityMunicipality(newValue)

            

          }}
          filterOptions={(options, params) => {
              const filtered = filter(options, params);

              return filtered;
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          onOpen={()=>{
              const newCityMunicipalityAutoCompeleteValue =  {id:0,psgcCode:"",citymunDesc:"",regDesc:"",provCode:"",citymunCode:""}
              setCityMunicipalityAutoCompeleteValue(newCityMunicipalityAutoCompeleteValue)

              const newBarangayAutoCompeleteValue = {id:0,brgyCode:"",brgyDesc:"",regCode:"",provCode:"",citymunCode:""}
              setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue)

              setDisableBarangayAutoSuggest(true)
              setDisableBarangayInput(true)

          }}

          onClose={(event,reason)=>{
              
            if(reason != 'selectOption'){
              // no selected data
              return
            }
             
              setDisableBarangayAutoSuggest(false)
              
          }}
          options={cityMunicipalityAutoCompeleteSuggestion}
          isOptionEqualToValue={(option, value) =>true}
          getOptionLabel={(option) => {
              
                  return option.citymunDesc;
          }}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.citymunDesc}>
                {option.citymunDesc}
              </li>
            );
          }}

          style={{ width: '100%'}}

          renderInput={(params) => (
              <TextField {...params} 
           
              InputProps={{ ...params.InputProps,className:classes.fullWidth}}
              className={classes.fullWidth}
              label={"City / Municipality *"}
              name="city_municipality_dsfasdf"
              id="province_"
              variant="outlined"
              onChange={(event)=>{
                  const newCityMunicipalityAutoCompeleteValue =  {id:0,psgcCode:"",citymunDesc:event.target.value,regDesc:"",provCode:"",citymunCode:""}
                
                  setCityMunicipalityAutoCompeleteValue(newCityMunicipalityAutoCompeleteValue)
              }}
               />
          )}
      />
    );
}

function barangayAutoComplete() {

    return (
      <Autocomplete
          disabled={disableBarangayAutoSuggest}
          value={barangayAutoCompeleteValue}
          noOptionsText={'No record found'}
          onChange={(event, newValue) => {
              
              if( newValue == null){
                  setSelectedBarangay(null)
                  return
              }
              setBarangayAutoCompeleteValue(newValue)
              setSelectedBarangay(newValue)

          }}
          filterOptions={(options, params) => {
              const filtered = filter(options, params);

              return filtered;
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          options={barangayAutoCompeleteSuggestion}
          onOpen={()=>{
              const newBarangayAutoCompeleteValue = {id:0,brgyCode:"",brgyDesc:"",regCode:"",provCode:"",citymunCode:""}
              setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue)
              setDisableBarangayInput(true)
          }}

          onClose={(event,reason)=>{
              
            if(reason != 'selectOption'){
              // no selected data
              return
            }
             
              setDisableBarangayInput(false)
              
          }}

          isOptionEqualToValue={(option, value) =>true}
          getOptionLabel={(option) => {
              
                  return option.brgyDesc;
          }}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.brgyDesc}>
                {option.brgyDesc}
              </li>
            );
          }}
          style={{ width: '100%'}}

          renderInput={(params) => (
              <TextField {...params} 
              InputProps={{ ...params.InputProps,className:classes.fullWidth,
                form: {
                  autoComplete: 'off',
                },autoComplete: 'new-password',
              }}
              className={classes.fullWidth}
              label={"Barangay *"}
              name="barangay"
              id="barangay"
              variant="outlined"
              
              onChange={(event)=>{

                  const newBarangayAutoCompeleteValue = {id:0,brgyCode:"",brgyDesc:event.target.value,regCode:"",provCode:"",citymunCode:""}
                
                  setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue)
              }}
               />
          )}
      />
    );
}
useEffect(()=>{

       console.log("Changed")

  if(provinceAutoCompeleteValue == null){
  
      fetchAutoSuggestProvinces("")
  }else{
      
      
      fetchAutoSuggestProvinces(provinceAutoCompeleteValue.provDesc)
  }
 
},[provinceAutoCompeleteValue])

useEffect(()=>{

  if(selectedProvince == null){
     return
  }

  if(cityMunicipalityAutoCompeleteValue == null){
 
     fetchAutoSuggestCitiesMunicipalities(selectedProvince.provCode,"")
  }else{
     
     fetchAutoSuggestCitiesMunicipalities(selectedProvince.provCode,cityMunicipalityAutoCompeleteValue.citymunDesc)
  }

},[cityMunicipalityAutoCompeleteValue])

useEffect(()=>{
  if(selectedProvince == null || selectedCityMunicipality == null){
      return
   }

   if(barangayAutoCompeleteValue == null){
      fetchAutoSuggestBarangays(selectedProvince.provCode,selectedCityMunicipality.citymunCode,"")

   }else{
      fetchAutoSuggestBarangays(selectedProvince.provCode,selectedCityMunicipality.citymunCode,barangayAutoCompeleteValue.brgyDesc)
   }

   
},[barangayAutoCompeleteValue])


function fetchAutoSuggestProvinces(searchString){
  
  const ourRequest = axios.CancelToken.source() // <-- 1st step
  
  const getProvinces = async () => {
     
      
      setAutoCompleteSearchOptionMessage("Searching")

      const options = {
        method: 'POST',
        url: '/TransactiLiteProvinces/getProvinceForAutoSuggest',
        cancelToken: ourRequest.token,
        data: objectToFormData({search_term:searchString})
      }
      const response = await axios(options)
        .then(res => {  
           const provinces = res.data.Provinces
           if(provinces.length <= 0){
             setAutoCompleteSearchOptionMessage("No record found.")

             setProvinceAutoCompeleteSuggestion([])
           }else{

              setProvinceAutoCompeleteSuggestion(provinces)
           }
         
        }).catch(error => {
          
         // alert("error")
          console.log(error)
          
  
        })
    }
    getProvinces()

    return () => {
       
      if (ourRequest !== undefined) {
         
          ourRequest.cancel() //
        }
    }
  
}

function fetchAutoSuggestCitiesMunicipalities(provinceCode,searchString){
  
  const ourRequest = axios.CancelToken.source() // <-- 1st step
  
  const getCitiesMunicipalities = async () => {
     
      
      setAutoCompleteSearchOptionMessage("Searching")

      const options = {
        method: 'POST',
        url: '/TransactiLiteCitiesMunicipalities/getCitiesMunicipalitiesForAutoSuggest',
        cancelToken: ourRequest.token,
        data: objectToFormData({provCode:provinceCode,search_term:searchString})
      }
      const response = await axios(options)
        .then(res => {
           const citiesMunicipalities = res.data.CitiesMunicipalities
           if(citiesMunicipalities.length <= 0){
             setAutoCompleteSearchOptionMessage("No record found.")

             setCityMunicipalityAutoCompeleteSuggestion([])
           }else{

              setCityMunicipalityAutoCompeleteSuggestion(citiesMunicipalities)
           }
         
        }).catch(error => {
          
         // alert("error")
          console.log(error)
          
  
        })
    }
    getCitiesMunicipalities()

    return () => {
       
      if (ourRequest !== undefined) {
          ourRequest.cancel()
        }
    }
  
}

function fetchAutoSuggestBarangays(provinceCode,cityMunicipalityCode,searchString){
  
  const ourRequest = axios.CancelToken.source() // <-- 1st step
  
  const getBarangays = async () => {
     
      
      setAutoCompleteSearchOptionMessage("Searching")

      const options = {
        method: 'POST',
        url: '/TransactiLiteBarangays/getBarangaysForAutoSuggest',
        cancelToken: ourRequest.token,
        data: objectToFormData({provCode:provinceCode,cityMunicipalityCode:cityMunicipalityCode,search_term:searchString})
      }
      const response = await axios(options)
        .then(res => {

          
           const barangays = res.data.Barangays
           
           if(barangays.length <= 0){
             setAutoCompleteSearchOptionMessage("No record found.")

             setBarangayAutoCompeleteSuggestion([])
           }else{

              setBarangayAutoCompeleteSuggestion(barangays)
           }
         
        }).catch(error => {
          
         // alert("error")
          console.log(error)
          
  
        })
    }
    getBarangays()

    return () => {
       
      if (ourRequest !== undefined) {
          ourRequest.cancel()
        }
    }
  
}

  
  const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    return formData;
  }, new FormData());

  const onFormSubmit = (event)=>{
    event.preventDefault();

    if(navigator.geolocation){

      setShowGettingLocationProgress(true)

      const successCallback = (position)=>{
        
        
        newUser.latitude = position.coords.latitude
        newUser.longitude = position.coords.longitude
        newUser.accuracy = position.coords.accuracy

        console.log(position)
        setShowGettingLocationProgress(false)
        createNewUser()

      }
      const errorCallback = (error)=>{
        setShowGettingLocationProgress(false)
        createNewUser()

      }
      navigator.geolocation.getCurrentPosition(successCallback,errorCallback)
     
    }else{
      
      createNewUser()
    }
   
   
   
    
  }

  function createNewUser(){

    if(selectedProvince == null || selectedCityMunicipality == null || selectedBarangay == null){

      setRegistrationErrors(["Province, Municipality and Barangay is required."])
      setHasErrorInRegistration(true)
      setOpenAlertDialog(true)
      return
  }

    const newUserCopy = {...newUser}
    newUserCopy.province = selectedProvince.provDesc
    newUserCopy.city = selectedCityMunicipality.citymunDesc
    newUserCopy.barangay = selectedBarangay.brgyDesc

   

    setShowRegisteringProgress(true)

    const options = {
      credentials: false,
      method: 'POST',
      url: '/User/register',
      data: objectToFormData(newUserCopy)
    }
    axios(options)
      .then(res => {
        console.log(res)

        setShowRegisteringProgress(false)

        const response = res.data;
        const isSucess = response.is_success;
        console.log(response)
        
        if(isSucess){
          
         
          setHasErrorInRegistration(false)

        }else{
          setRegistrationErrors(response.errors)
          setHasErrorInRegistration(true)
        }
        setOpenAlertDialog(true)
        
      }).catch(error => {
         
         if (typeof error.response == 'undefined') {
          // network error
          setRegistrationErrors([`Please checkout your internet connection.`])
        }else{
          setRegistrationErrors([`Failed to register. Code ${error.response.status}`])
        }
        setShowRegisteringProgress(false)
        setHasErrorInRegistration(true)
        setOpenAlertDialog(true)
      })

  }
  
  useEffect(() => {
   console.log("openAlertDialog change")
    
    console.log(registrationErrors)

  },[registrationErrors])

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <form className={classes.form} autoComplete="off" onSubmit={onFormSubmit}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="fname"
                  name="firstName"
                  variant="outlined"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                  onChange={firstNameOnChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  onChange={lastNameOnChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="username"
                  label="Username"
                  name="username"
                  onChange={usernameOnChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  onChange={passwordOnChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Reenter Password"
                  type="password"
                  id="reenter-password"
                  autoComplete="current-password"
                  onChange={retypePasswordOnChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  label="Store Name"
                  onChange={storeNameOnChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="mobile-number"
                  label="Mobile Phone Number"
                  name="mobile-number"
                  onChange={mobileNumberOnChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email-address"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  onChange={emailOnChange}
                />
              </Grid>

              <Grid item xs={12}>
                
                {provinceAutoComplete()}
              </Grid>

           
              <Grid item xs={12}>
                {cityMunicipalityAutoComplete()}
              </Grid>
              
              <Grid item xs={12}>
                {barangayAutoComplete()}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="street"
                  label="Street"
                  name="street"
                  onChange={streetOnChange}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox value="allowExtraEmails" color="primary" onChange={endUserAgreementhOnChange} />}
                  label="Agree to End User Agreement."
                />
              </Grid>
            
             
            </Grid>
            </ThemeProvider>
        </StyledEngineProvider>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign Up
          </Button>
          <Grid container>
            <Grid item>
              <Link href="#" variant="body2" style={{ color: "black" }} onClick={()=>{props.setIsSignUp(false)}}>
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        {/* <Copyright /> */}
      </Box>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
        {progressDialog()}
        {alertDialog()}
        {gettinLocationProgressDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </Container>
  );
}